
  import { Evaluation } from '@/entities/loans'
  import { Component } from 'vue-property-decorator'
  import FinancerDashboard from './FinancerDashboard'

@Component
  export default class FinancerEvaluations extends FinancerDashboard {
    excludedSettingsTables = [
      'executives',
      'purchase_order',
      'sale_order',
      'inspection',
      'reserve',
      'stock',
      'negotiation',
      'appraisal',
      'lead',
    ]

    canceledClosingReason = null
    crIdOffset = 500

    async mounted () {
      this.canceledClosingReason = (await this.fetchData({
        query: { name: 'find', model: 'ClosingReason' },
        filter: {
          _and: [
            { status: { process: { table_name: { _eq: 'evaluation' } } } },
            { type: { name: { _eq: 'canceled' } } },
          ],
        },
      }))[0]
      this.canceledClosingReason.id += this.crIdOffset
    }

    data () {
      return {
        Evaluation,
      }
    }

    // Methods
    beforeCreate () {
      this.getData = async () => {
        // this.$set(this.specificChartData.currentMonth, 'inspections', await this.getInspections(this.specificCurrentMonthFilters.startEndDate))
        // this.$set(this.specificChartData.prevMonth, 'inspections', await this.getInspections(this.specificPrevMonthFilters.startEndDate))
      }
    }

  // Getters

  // Watchers
  }
